import { useSelector } from "react-redux";

export const useBlogSelectors = () => {
  const facts = useSelector(state => state.blog.content.facts);
  const blog = useSelector(state => state.blog.content.blog);

  return {
    allFacts: facts.data,
    isFactsDataLoaded: facts.isDataLoaded,
    isFactsLoading: facts.isLoading,
    factsError: facts.isError,
    blogLanguage: facts.languageCode,

    blogData: blog.data,
    isBlogDataLoaded: blog.isDataLoaded,
    isBlogLoading: blog.isLoading,
    blogError: blog.isError,
  };
};
